export const VIEW_OPTIONS_CONSTANTS = {
  grid: 'grid',
  list: 'list',
};
